module.exports = __webpack_public_path__ + "static/media/reports.e5b82462.svg";